export enum TextMessageTypeId {
  Sent_By_System = 1,
  Sent_By_User = 2,
  Sent_By_Patient = 3,
}
